// extracted by mini-css-extract-plugin
module.exports = {"FlashMessage":"FlashMessage_FlashMessage__78DwX","fadeOut":"FlashMessage_fadeOut__L8bjj"};